import React from 'react';
import useCarousel from '../../Common/useCarousel';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

const Carousel = ({ content, count, lazyload }) => {
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
    leftCursor,
    rightCursor,
  } = useCarousel(content, count ? count : 2);
  return (<div className="makeFlex relative offerCarousel">
    <div className="holtelCarousel">
      <div className="filterSlider">
        {dataList.map((obj, index) => {
          const { img_url, url, slug, sub_heading, validity_text } = obj;
          return (
            <>
              {lazyload ?
                <img key={img_url + slug + url + index} className="sliderImg lazyload" data-src={obj.img_url} alt="Bus" onClick={() => {
                  if (url) {
                    window.open(url);
                  }
                }} />
                :
                <img key={img_url + slug + url + index} className="sliderImg" src={obj.img_url} alt="Bus" onClick={() => {
                  if (url) {
                    window.open(url);
                  }
                }} />
              }
              <div className="sliderInfoWrap" onClick={() => {
                if (url) {
                  window.open(url);
                }
              }}>
                <p className="sliderHeadInfo">{sub_heading}</p>
                <p className="sliderInfoSubtext">{validity_text}</p>
              </div>
            </>
          )
        })}

      </div>
      <div className="sliderNavSlider">
        {isLeftCursorActive ? <p className="filterPrev" onClick={() => {
          decrement();
        }}><button>.</button></p> : null}
        {isRightCursorActive ? <p className="filterNext" onClick={() => {
          increment();
        }}><button >.</button></p> : null}
      </div>
    </div>
  </div>)
}

Carousel.defaultProps = {
  lazyload: true
};

export default Carousel;
